<template>
  <div>
    <apexchart
      type="line"
      height="240"
      ref="chart_mix"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
  name: "MultipleLineChart",

  components: {
    apexchart: VueApexCharts,
  },

  props: {
    y1SensorType: {
      type: String,
      default: "FLOW"
    },
    y2SensorType: {
      type: String,
      default: "TOT"
    },
    y1Data: {
      type: Array,
      default: () => []
    },
    y2Data: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    reloadChart: false,
    series: [
      {
        name: "TDS",
        type: "line",
        data: [{
          'x': "",
          'y': 0
        }],
      },
      {
        name: "EC",
        type: "line",
        data: [{
          'x': "",
          'y': 0
        }],
      },
    ],
    chartOptions: {
      chart: {
        animations: {
          enabled: false,
        },
        height: 350,
        type: "line",
        toolbar: {
          show: false,
        },
      },
      stroke: {
        curve: "straight",
      },
      fill: {
        type: "solid",
      },
      labels: [],
      markers: {
        size: 0,
      },
      xaxis: {
        type: 'time',
        tickAmount: 6,
        labels: {
          rotate: 0,
        },
      },
      yaxis: [
        {
          title: {
            text: "TDS (PPM)",
          },
        },
        {
          opposite: true,
          title: {
            text: "EC (μS/cm)",
          },
        },
      ],
      tooltip: {
        shared: true,
        intersect: false,
        x: {
          format: 'HH:mm:ss',
        },
        y: {},
      },
    },
  }),

  watch: {
    y1Data: function(newVal) {
      this.series[0].data = newVal;
      // this.setChartPropertiesY1();
      this.$refs.chart_mix.refresh();
    },
    y2Data: function(newVal) {
      this.series[1].data = newVal;
      // this.setChartPropertiesY2();
      this.$refs.chart_mix.refresh();
    },
  },

  methods: {
    setChartPropertiesY1() {
      switch (this.y1SensorType) {
        case "FLOW":
          this.series[0].name = "Flow";
          this.chartOptions.yaxis[0].title.text = "Flow (M^3/Hr)";
          break;
        case "LEVEL":
          this.series[0].name = "Level";
          this.chartOptions.yaxis[0].title.text = "Level (M)";
          break;
      
        default:
          break;
      }
    },
    setChartPropertiesY2() {
      switch (this.y2SensorType) {
        case "TOT":
          this.series[1].name = "Total";
          this.chartOptions.yaxis[1].title.text = "Total (M^3)";
          break;
        case "TDS":
          this.series[1].name = "TDS";
          this.chartOptions.yaxis[1].title.text = "TDS (PPM)";
          break;
      
        default:
          break;
      }
    },
  },
  
  mounted() {
    this.setChartPropertiesY1();
    this.setChartPropertiesY2();
  }

};
</script>

<style>
</style>